import React from "react";
import { AvatarUser } from "../../components/AvatarUser";
import {
  HeaderWrapper,
  LeftWrapper,
  MainWrapper,
  ProfileWrapper,
  RightWrapper,
  Title,
  ToggleButtonWrapper,
  Label,
  Input,
  Slider,
  InfoContainer,
  Text,
  TextBold,
  UserTypeContainer,
  UserTypeTextBold,
  UserTypeText,
  SwitchContainer,
  IconContainer,
  TextContainer,
} from "./styles";
import { PersonalDataCard } from "../../components/PersonalDataCard/PersonalDataCard";
import { Divider, Stack, Typography } from "@mui/material";
import Switch, { SwitchProps } from "@mui/material/Switch";
import { getUserById } from "../../services/user/getUser";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "../../routes/constants";
import { styled } from "@mui/material/styles";
import { SupervisorAccount } from "@mui/icons-material";
import theme from "../../theme/theme";

const IOSSwitch = styled((props: SwitchProps) => (
  <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
  width: 42,
  height: 26,
  padding: 0,
  "& .MuiSwitch-switchBase": {
    padding: 0,
    margin: 2,
    transitionDuration: "300ms",
    "&.Mui-checked": {
      transform: "translateX(16px)",
      color: "#fff",
      "& + .MuiSwitch-track": {
        backgroundColor: theme.palette.mode === "dark" ? "#2ECA45" : "#65C466",
        opacity: 1,
        border: 0,
      },
      "&.Mui-disabled + .MuiSwitch-track": {
        opacity: 0.5,
      },
    },
    "&.Mui-focusVisible .MuiSwitch-thumb": {
      color: "#33cf4d",
      border: "6px solid #fff",
    },
    "&.Mui-disabled .MuiSwitch-thumb": {
      color:
        theme.palette.mode === "light"
          ? theme.palette.grey[100]
          : theme.palette.grey[600],
    },
    "&.Mui-disabled + .MuiSwitch-track": {
      opacity: theme.palette.mode === "light" ? 0.7 : 0.3,
    },
  },
  "& .MuiSwitch-thumb": {
    boxSizing: "border-box",
    width: 22,
    height: 22,
  },
  "& .MuiSwitch-track": {
    borderRadius: 26 / 2,
    backgroundColor: theme.palette.mode === "light" ? "#E9E9EA" : "#39393D",
    opacity: 1,
    transition: theme.transitions.create(["background-color"], {
      duration: 500,
    }),
  },
}));

export const Profile = () => {
  const navigate = useNavigate();

  const jwt = localStorage.getItem("jwt");
  const userId = localStorage.getItem("user_id");
  const userType = localStorage.getItem("user_type");

  const [userName, setUserName] = React.useState("");
  const [userLastName, setUserLastName] = React.useState("");

  // ------------------- API REQUEST -------------------
  const getUser = async () => {
    if (userId) {
      await getUserById(parseInt(userId), jwt!)
        .then((res: any) => {
          if (res && res.data) {
            setUserName(res.data.user.name);
            setUserLastName(res.data.user.lastname);
          }
        })
        .catch((err: any) => {
          console.log(err, "err");
        });
    }
  };

  // ------------------- USE EFFECT -------------------

  React.useEffect(() => {
    getUser();
  }, []);

  const view = localStorage.getItem("view");
  const [isAdmin, setIsAdmin] = React.useState(view === "admin");

  const handleToggle = () => {
    if (isAdmin) {
      localStorage.setItem("view", "user");
      navigate(`${ROUTES.PROFILE}`);
    } else {
      localStorage.setItem("view", "admin");
      navigate(`${ROUTES.ADMIN}${ROUTES.PROFILE}`);
    }
  };

  return (
    <ProfileWrapper>
      <HeaderWrapper>
        <Title>Mi Perfil</Title>
      </HeaderWrapper>
      <Divider sx={{ marginBottom: "20px" }} />
      <MainWrapper>
        <LeftWrapper>
          <AvatarUser size="Large" edit={true} />
          {userType === "1" ? (
            <UserTypeContainer>
              <IconContainer>
                <SupervisorAccount
                  sx={{
                    color: theme.color.white,
                    backgroundColor: theme.color.apricot,
                    padding: "2px",
                    borderRadius: "5px",
                  }}
                />
              </IconContainer>
              <TextContainer>
                {isAdmin ? (
                  <UserTypeText>Usuario</UserTypeText>
                ) : (
                  <UserTypeTextBold>Usuario</UserTypeTextBold>
                )}
                <UserTypeText>/</UserTypeText>
                {isAdmin ? (
                  <UserTypeTextBold>Administrador</UserTypeTextBold>
                ) : (
                  <UserTypeText>Administrador</UserTypeText>
                )}
              </TextContainer>

              <SwitchContainer>
                <IOSSwitch
                  sx={{ m: 1 }}
                  checked={isAdmin}
                  onChange={handleToggle}
                />
              </SwitchContainer>
            </UserTypeContainer>
          ) : null}
        </LeftWrapper>
        <RightWrapper>
          <PersonalDataCard />
        </RightWrapper>
      </MainWrapper>
    </ProfileWrapper>
  );
};

export default Profile;
